import React, { useState,useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import room1 from '../../../images/sb-images/r1.jpeg';
import room2 from '../../../images/sb-images/r2.jpeg';
import seat1 from '../../../images/sb-images/s1.jpeg';
import seat2 from '../../../images/sb-images/s2.jpeg';
import { TabContent, TabPane,  NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import Swal from "sweetalert2";
const RoomSeatMaster = () => {
    const [activeTab, setActiveTab] = useState('1');
    const [isLogin, setIsLogin] = useState(false);
    const history = useHistory();
    const [rooms, setRooms] = useState([]);
    const [roomName, setroomName] = useState('');
  const [roomCapacity, setroomCapacity] = useState('');
  const [description, setDescription] = useState('');
  const [roomImage, setroomImage] = useState('');
  const [roomid, setRoomid] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [currentPages, setCurrentPages] = useState(1);
  const [totalItemss, setTotalItemss] = useState(0);
  const [startIndexs, setStartIndexs] = useState(0);
  const [show, setShow] = useState(false);
  const [showseat, setShowseat] = useState(false);
  const [roomToDelete, setroomDelete] = useState('');
  const itemsPerPage = 15; 
  const itemsPerPages = 15; 
  const [seats, setSeats] = useState([]);
  const [seatName, setseatName] = useState('');
  const [seatdescription, setseatDescription] = useState('');
  const [seatImage, setseatImage] = useState('');
  const [editModeseat, setEditModeSeat] = useState(false);
  const [seatid, setseatid] = useState('');
  const [seatToDelete, setseatDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchQuery, setSearchQuery] = useState('');


  useEffect(() => {
    fetchRoomData();
    fetchSeatData();
}, [currentPage]);

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
      }

      const fetchRoomData = async () => {
        const token = localStorage.getItem('token');
        const startIndexCalc = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndexCalc + itemsPerPage;
        setIsLogin(true);
        try {
            const response = await axios.get(`${var_api}/api/masters/room-master/get`, {
                headers: {
                    'Authorization': `${token}`
                }
            });
            const roommaster = response.data;
            // setEmployee(response.data);
            if (roommaster.length > 0) {
              setRooms(roommaster.slice(startIndexCalc, endIndex));
                setTotalItems(roommaster.length);
                setStartIndex(startIndexCalc); // Update startIndex state variable
            } else {
                console.log('No data found.');
                setRooms([]);
                setTotalItems(0);
                setStartIndex(0); // Reset startIndex state variable
            }
            setIsLogin(false);
        } catch (error) {
            console.log('Error fetching data:', error);
            if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
            setRooms([]);
        }
    };

    // const capitalizeEachWord = (str) => {
    //   return str.toLowerCase().replace(/(^|\s)\S/g, function (match) {
    //     return match.toUpperCase();
    //   });
    // };

      const RoomMasterpost = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        setIsLogin(true);
        // const camelCaseRoomName = capitalizeEachWord(roomName);
        
        // const defaultImagePath = '/images/img/room.jpeg'; // Adjust this path
    
        // Create a new FormData object
        const formData = new FormData();
        formData.append('room_name', roomName);
        formData.append('room_description', description);
        formData.append('room_capacity', roomCapacity);
        formData.append('room_status', 1);
        formData.append('room_image', roomImage || "");
        // formData.append('room_image', roomImage);
      //   if (roomImage) {
      //     // If a file is selected, append the file to formData
      //     formData.append('room_image', roomImage);
      // } else {
      //     // If no file is selected, load and append the default image as binary
      //     try {
      //         const response = await fetch(defaultImagePath);
      //         const blob = await response.blob();
      //         formData.append('room_image', blob, 'room.jpg'); // 'seat.jpg' is a default file name
      //     } catch (error) {
      //         console.error('Error loading default image:', error);
      //     }
      // }
    
        try {
          let response;
            if (editMode) {
              response =  await axios.put(`${var_api}/api/masters/room-master/put/${roomid}`, formData, {
                    headers: {
                        'Authorization': `${token}`
                    }
                });
    
            } else {
              response =  await axios.post(`${var_api}/api/masters/room-master/post`, formData, {
                    headers: {
                        'Authorization': `${token}`
                    }
                });
               
            }
            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                text: editMode ? 'Room Updated Successfully' : 'Room Created Successfully',
                confirmButtonColor: '#007500',
              });
              console.log(editMode ? 'Room updated successfully!' : 'Room created successfully!');
            }
            setIsLogin(false);
            fetchRoomData();
            resetForm();
        } catch (error) {
            setIsLogin(false);
            console.error('Error:', error);
            if (error.response && error.response.status === 401) {
                history.push('/signin');
            }else{
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response?.data?.error || 'Something went wrong!',
                confirmButtonColor: '#007500',
              });
            }
        }finally {
          setIsLogin(false);
        }
    };

    const handleEdit = (room) => {
      setEditMode(true);
      setRoomid(room.id);
      setroomName(room.room_name);
      setDescription(room.room_description);
      setroomCapacity(room.room_capacity);
      setroomImage(room.room_image);  
    };
    const handleOpenConfirmation = (room) => {
      console.log('roomid',room.id);
      setroomDelete(room.id);
      setShow(true);
  };
  
  const handleCloseConfirmation= ()=>{
      setShow(false)
    };
    const resetForm = () => {
      setEditMode(false);
      setroomName('');
      setDescription('');
      setroomCapacity('');
      setroomImage(null);
       // Reset file input manually
    document.getElementById('roomImageInput').value = '';
  };
  
  const handleDelete = async () => {
      const token = localStorage.getItem('token');
      setIsLogin(true);
      try {
          await axios.delete(`${var_api}/api/masters/room-master/delete/${roomToDelete}`, {
              headers: {
                  'Authorization': `${token}`
              }
          });
          console.log('Role deleted successfully!');
          fetchRoomData();
          handleCloseConfirmation();
          setIsLogin(false);
      } catch (error) {
          console.error('Error deleting role:', error);
          if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
      }
  };

  //seat get

  const fetchSeatData = async () => {
    const token = localStorage.getItem('token');
    const startIndexCalcs = (currentPages - 1) * itemsPerPages;
const endIndexs = startIndexCalcs + itemsPerPages;
    setIsLogin(true);
    try {
        const response = await axios.get(`${var_api}/api/masters/seat-master/get`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        const seatmaster = response.data;
        if (seatmaster.length > 0) {
          setSeats(seatmaster.slice(startIndexCalcs, endIndexs));
            setTotalItemss(seatmaster.length);
            setStartIndexs(startIndexCalcs); // Update startIndex state variable
        } else {
            console.log('No data found.');
            setSeats([]);
            setTotalItemss(0);
            setStartIndexs(0); // Reset startIndex state variable
        }
        setIsLogin(false);
    } catch (error) {
        console.log('Error fetching data:', error);
        if (error.response && error.response.status === 401) {
          history.push('/signin');
      }
        setSeats([]);
    }
};
const seatMasterpost = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem('token');
  setIsLogin(true);
console.log("seat", seatImage);
// const defaultImagePath = '/images/img/seat.jpeg'; // Adjust this path

  // Create a new FormData object
  const formData = new FormData();
  formData.append('seat_name', seatName);
  formData.append('seat_description', seatdescription);
  formData.append('seat_status', 1);
  formData.append('seat_image', seatImage || "");
  // formData.append('seat_image', seatImage);
//   if (seatImage) {
//     // If a file is selected, append the file to formData
//     formData.append('seat_image', seatImage);
// } else {
//     // If no file is selected, load and append the default image as binary
//     try {
//         const response = await fetch(defaultImagePath);
//         const blob = await response.blob();
//         formData.append('seat_image', blob, 'seat.jpg'); // 'seat.jpg' is a default file name
//     } catch (error) {
//         console.error('Error loading default image:', error);
//     }
// }

  try {
    let response;
      if (editModeseat) {
        response = await axios.put(`${var_api}/api/masters/seat-master/put/${seatid}`, formData, {
              headers: {
                  'Authorization': `${token}`
              }
          });
      } else {
        response = await axios.post(`${var_api}/api/masters/seat-master/post`, formData, {
              headers: {
                  'Authorization': `${token}`
              }
          });
      }

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: editModeseat ? 'Seat Updated Successfully' : 'Seat Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log(editModeseat ? 'Seat updated successfully!' : 'seat created successfully!');
      }
      setIsLogin(false);
      fetchSeatData();
      resetFormSeat();
  } catch (error) {
      setIsLogin(false);
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
          history.push('/signin');
      }else{
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }finally {
    setIsLogin(false);
  }
};


  const handleFileChange = (e) => {
    setroomImage(e.target.files[0]);
  };

  const handleFileChangeSeat = (e) => {
    setseatImage(e.target.files[0]);
    console.log("seat", seatImage);
  };

const handleEditseat = (seat) => {
  setEditModeSeat(true);
  setseatid(seat.id);
  setseatName(seat.seat_name);
  setseatDescription(seat.seat_description);
  setseatImage(seat.seat_image);  
};
const resetFormSeat = () => {
  setEditModeSeat(false);
  setseatName('');
  setseatDescription('');
  setroomImage(null);
   // Reset file input manually
   document.getElementById('seatImageInput').value = '';
};
const handleDeleteseat = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      await axios.delete(`${var_api}/api/masters/seat-master/delete/${seatToDelete}`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      console.log('Role deleted successfully!');
      fetchSeatData();
      handleCloseConfirmationseat();
      setIsLogin(false);
  } catch (error) {
      console.error('Error deleting role:', error);
      if (error.response && error.response.status === 401) {
          history.push('/signin');
      }
  }
};
const handleOpenConfirmationseat = (roomID) => {
  setseatDelete(roomID);
  setShowseat(true);
};

const handleCloseConfirmationseat= ()=>{
  setShowseat(false)
};

const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};

const handleSearchChangeSeat = (e) => {
  setSearchQuery(e.target.value);
};


const filteredRooms = rooms.filter(room => 
  room.room_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  room.room_description.toLowerCase().includes(searchTerm.toLowerCase()) ||
  room.room_capacity.toString().includes(searchTerm)
);

const filteredSeats = seats.filter((seat) =>
  seat.seat_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
seat.seat_description.toLowerCase().includes(searchQuery.toLowerCase()) 

);


const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const handlePageChanges = (pageNumber) => {
  setCurrentPages(pageNumber);
};



 //go to home
 const handleGoToHome = () => {
  history.push('/sb-home');
}


const handleroomStatusChange = async (room, newStatus) => {
  const token = localStorage.getItem('token');
  setIsLogin(true);

  const formData = new FormData();
  formData.append('room_name', room.room_name);
  formData.append('room_description', room.room_description);
  formData.append('room_capacity', room.room_capacity);
  formData.append('room_status', newStatus);
  formData.append('room_image', room.room_image);

  try {
    const response = await axios.put(`${var_api}/api/masters/room-master/put/${room.id}`, formData, {
      headers: {
        'Authorization': `${token}`
      }
    });

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Room Status Updated Successfully',
        confirmButtonColor: '#007500',
      });
      console.log('Room status updated successfully!');
    }
    fetchRoomData();
  } catch (error) {
    console.error('Error:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  } finally {
    setIsLogin(false);
  }
};


const handleStatusChange = async (seat, newStatus) => {
  const token = localStorage.getItem('token');
  setIsLogin(true);

  const formData = new FormData();
  formData.append('seat_status', newStatus);
  formData.append('seat_name', seat.seat_name);
  formData.append('seat_description', seat.seat_description);
  formData.append('seat_image', seat.seat_image);

  try {
    const response = await axios.put(`${var_api}/api/masters/seat-master/put/${seat.id}`, formData, {
      headers: {
        'Authorization': `${token}`
      }
    });

    if (response.status === 200) {
      Swal.fire({
        icon: 'success',
        text: 'Seat Status Updated Successfully',
        confirmButtonColor: '#007500',
      });
      console.log('Seat status updated successfully!');
    }
    fetchSeatData();
  } catch (error) {
    console.error('Error:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  } finally {
    setIsLogin(false);
  }
};


return(
        <>
        {isLogin && <Loader />}  
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       ROOM & SEAT MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome}  style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
<div className="d-flex justify-content-center mt-3">
      <Nav tabs>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
            style={{ backgroundColor: activeTab === '1' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '1' ? 'white' : 'black' }}
          >
            ROOMS
          </NavLink>
        </NavItem>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
            style={{ backgroundColor: activeTab === '2' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '2' ? 'white' : 'black' }}
          >
            SEATS
          </NavLink>
        </NavItem>
      </Nav>
    </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row>
            <Col sm="12">
            <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
  <Card style={{ border: "none", maxWidth:"28rem", padding:"15px 27px", margin:"auto", height:"auto", borderRadius:"20px", boxShadow:"rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
    {/* <Card.Header>Create Employee</Card.Header> */}
    <Card.Body>
        <h5 style={{textAlign:"center", color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Create Room</h5>
      <Form onSubmit={RoomMasterpost}>
        <Form.Group controlId="formBasicName" className="mt-3">
          <Form.Label>Room Name</Form.Label>
          <Form.Control type="text" placeholder="Enter room name" value={roomName}
                            onChange={(e) =>  setroomName(e.target.value)} required/>
          {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
        </Form.Group>

        <Form.Group controlId="formBasicCapacity" className="mt-3">
          <Form.Label>Room Capacity</Form.Label>
          <Form.Control type="number" placeholder="Enter capacity" value={roomCapacity}
                            onChange={(e) =>  setroomCapacity(e.target.value)} />
          {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
        </Form.Group>

       
        <Form.Group controlId="formBasicDescription" className="mt-3">
          <Form.Label>Description</Form.Label>
          <Form.Control type="text" placeholder="Enter description" value={description}
                            onChange={(e) =>  setDescription(e.target.value)} />
        </Form.Group>

        <Form.Group controlId="formBasicProfile" className="mt-3">
          <Form.Label>Room Image</Form.Label>
          <Form.Control type="file" placeholder="Select File" onChange={handleFileChange}   id="roomImageInput"/>
          {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
        </Form.Group>


        {/* <Form.Group controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}

<Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} >
            {editMode ? 'Update' : 'Submit'}
        </Button>{" "}
        <Button variant="danger"  className="mt-3" onClick={resetForm} >
          Reset
        </Button>
      </Form>
    </Card.Body>
  </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Room List 
                 <span style={{float:"right"}}>  <Form.Control type="text" placeholder="Search..."  value={searchTerm} 
          onChange={handleSearchChange} /></span>
                 </h5> 
                 <h6 style={{color:"rgba(50, 103, 19)", marginTop:"5px"}}>Rooms Count: {rooms.length}</h6>   
                 <Table responsive className="mt-3">
  <thead>
    <tr>
      <th>S.No</th> 
      <th>Image</th>
      <th>Name</th>
      <th>Capacity</th>
      <th>Description</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {filteredRooms.length > 0 ? (
      filteredRooms.map((room, index) => (
        <tr key={room.id}>
          <td>{startIndex + index + 1}</td>
          <td>
            <img 
              src={room.room_image ? `${var_api}/${room.room_image}` : "/images/img/room.jpg"} 
              alt="profile" 
              width="75px" 
              height="75px" 
            />
          </td>
          <td>{room.room_name}</td>
          <td>{room.room_capacity}</td>
          <td>{room.room_description}</td>
          <td>
            <Form.Check 
              type="switch" 
              id={`custom-switch-${room.id}`} 
              label="" 
              checked={room.room_status === 1} 
              onChange={(e) => handleroomStatusChange(room, e.target.checked ? 1 : 0)} 
            />
          </td>
          <td>
            <Button variant="primary" type="button" className="m-1" onClick={() => handleEdit(room)}>
              <i className="bi bi-pencil-square"></i>
            </Button>
            {/* <Button variant="danger" type="button" className="m-1" onClick={() => handleOpenConfirmation(room)}>
              <i className="bi bi-trash"></i>
            </Button> */}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center">No data available</td>
      </tr>
    )}
  </tbody>
</Table>

<Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={totalItems} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
      </Card>
                </Col>
            </Row>
        </div>
            </Col>
          </Row>
        </TabPane>



        <TabPane tabId="2">
          <Row>
            <Col sm="12">
            <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
  <Card style={{ border: "none", maxWidth:"28rem", padding:"15px 27px", margin:"auto", height:"auto", borderRadius:"20px", boxShadow:"rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
    {/* <Card.Header>Create Employee</Card.Header> */}
    <Card.Body>
        <h5 style={{textAlign:"center", color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Create Seat</h5>
      <Form onSubmit={seatMasterpost} >
        <Form.Group controlId="formBasicName" className="mt-3">
          <Form.Label>Seat Name</Form.Label>
          <Form.Control type="text" placeholder="Enter seat name" value={seatName}
                            onChange={(e) =>  setseatName(e.target.value)} required />
          {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
        </Form.Group>

       
        <Form.Group controlId="formBasicDescription" className="mt-3">
          <Form.Label>Description</Form.Label>
          <Form.Control type="text" placeholder="Enter description" value={seatdescription}
                            onChange={(e) =>  setseatDescription(e.target.value)} />
        </Form.Group>

        <Form.Group controlId="formBasicProfile" className="mt-3">
          <Form.Label>Seat Image</Form.Label>
          <Form.Control type="file" placeholder="Select File"  onChange={handleFileChangeSeat} id="seatImageInput" />
          {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
        </Form.Group>


        {/* <Form.Group controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}

<Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} >
            {editModeseat ? 'Update' : 'Submit'}
        </Button>{" "}
        <Button variant="danger" className="mt-3" onClick={resetFormSeat} >
          Reset
        </Button>
      </Form>
    </Card.Body>
  </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Seat List  <span style={{float:"right"}}>  <Form.Control type="text" placeholder="Search..."   value={searchQuery}
            onChange={handleSearchChangeSeat}/></span></h5> 
                 <h6 style={{color:"rgba(50, 103, 19)", marginTop:"5px"}}>Seats Count: {seats.length}</h6>     
                 <Table responsive className="mt-3">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Image</th>
          <th>Name</th>
          <th>Description</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {filteredSeats.length > 0 ? (
        
        filteredSeats.map((seat, index) => (
          <tr key={seat.id}>
            <td>{startIndex + index + 1}</td>
            <td>
              {/* <img src={`${var_api}/${seat.seat_image}`} alt="profile" width="75px" height="75px" /> */}
              <img 
              src={seat.seat_image ? `${var_api}/${seat.seat_image}` : "/images/img/seat.jpg"} 
              alt="profile" 
              width="75px" 
              height="75px" 
            />
            </td>
            <td>{seat.seat_name}</td>
            <td>{seat.seat_description}</td>
            <td>
            <Form.Check 
              type="switch" 
              id={`custom-switch-${seat.id}`} 
              checked={seat.seat_status === 1}
              onChange={(e) => handleStatusChange(seat, e.target.checked ? 1 : 0)} 
            />
            </td>
            <td>
              <Button
                variant="primary"
                className="m-1"
                onClick={() => handleEditseat(seat)}
              >
                <i className="bi bi-pencil-square"></i>
              </Button>{" "}
              {/* <Button
                variant="danger"
                className="m-1"
                onClick={() => handleOpenConfirmationseat(seat.id)}
              >
                <i className="bi bi-trash"></i>
              </Button> */}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="7" className="text-center">No data available</td>
        </tr>
      )}
      </tbody>
    </Table>
    <Pagination
    activePage={currentPages}
    itemsCountPerPage={itemsPerPages}
    totalItemsCount={totalItemss} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChanges}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
      </Card>
                </Col>
            </Row>
        </div>
            </Col>
          </Row>
        </TabPane>
      </TabContent>

      <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        show={showseat}
        onHide={handleCloseConfirmationseat}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmationseat}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDeleteseat}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    )
}

export default RoomSeatMaster;